const PRODUCT_CARD_RESTORE_KEY = 'mughal:last-product-card';

export const saveProductCardPosition = (productId) => {
  const path = `${window.location.pathname}${window.location.search}`;
  sessionStorage.setItem(
    PRODUCT_CARD_RESTORE_KEY,
    JSON.stringify({ path, productId: String(productId) })
  );
};

export const restoreProductCardPosition = () => {
  const savedPosition = sessionStorage.getItem(PRODUCT_CARD_RESTORE_KEY);
  if (!savedPosition) return;

  let position;
  try {
    position = JSON.parse(savedPosition);
  } catch (error) {
    sessionStorage.removeItem(PRODUCT_CARD_RESTORE_KEY);
    return;
  }

  const currentPath = `${window.location.pathname}${window.location.search}`;
  if (position.path !== currentPath || !position.productId) return;

  const restore = () => {
    const card = document.getElementById(`product-card-${position.productId}`);
    if (!card) return;

    card.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'auto' });
    sessionStorage.removeItem(PRODUCT_CARD_RESTORE_KEY);
  };

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(restore);
  });
};
